import { render, staticRenderFns } from "./textOptions.vue?vue&type=template&id=5c76d666&lang=pug&"
import script from "./textOptions.vue?vue&type=script&lang=js&"
export * from "./textOptions.vue?vue&type=script&lang=js&"
import style0 from "./textOptions.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports